import actions from '../utils/restActions';
const authentication = (state = {}, action) => {
    switch (action.type) {
    case  actions.session.get.status.success: {

	return Object.assign({}, state, {authenticated: true});
    }
    case  actions.session.create.status.success: {

	return Object.assign({}, state, {authenticated: true});
    }
    case  actions.session.delete.status.success: {
	return Object.assign({}, state, {authenticated: false});
    }
    default:
	return state;
    }
}

export default authentication;



// WEBPACK FOOTER //
// ./src/reducers/Session.js